"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _queryString = require("query-string");
var _urlHelpers = require("../urlHelpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fvAnonParameter = {
  FVAnon: 'true'
};
var DESIGNER_PATH = 'Designer';
var urlBuilder = function urlBuilder(queryString) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    baseUrl = _ref.baseUrl;
  var base = baseUrl ? (0, _urlHelpers.ensureSlash)(baseUrl) : '/';
  var parameters = (0, _queryString.parse)(queryString);
  var makeUrl = function makeUrl(path) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, _urlHelpers.buildUrl)(base + path, parameters, params);
  };
  var templateUrl = function templateUrl(relativePath) {
    return function (templateName) {
      return makeUrl(relativePath, {
        templateName: templateName
      });
    };
  };
  var downloadTemplate = templateUrl('Forms/DownloadTemplate');
  var viewForm = function viewForm(templateName) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$anonymous = _ref2.anonymous,
      anonymous = _ref2$anonymous === void 0 ? false : _ref2$anonymous;
    return makeUrl('FormsViewer/View', _objectSpread({
      templateName: templateName
    }, anonymous ? fvAnonParameter : null));
  };
  var templateFile = function templateFile(templateName, instanceId, fileName) {
    var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref3$anonymous = _ref3.anonymous,
      anonymous = _ref3$anonymous === void 0 ? false : _ref3$anonymous;
    return makeUrl('Forms/TemplateFile', _objectSpread({
      templateName: templateName,
      instanceId: instanceId,
      fileName: fileName
    }, anonymous ? fvAnonParameter : null));
  };
  var manageTemplates = function manageTemplates() {
    return makeUrl('FormsViewer/ManageTemplates');
  };
  var uploadTemplate = function uploadTemplate() {
    var templateName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return makeUrl('FormsViewer/UploadTemplate', templateName ? {
      formName: templateName,
      update: 'true'
    } : {});
  };
  var designer = templateUrl(DESIGNER_PATH);
  var createTemplate = function createTemplate() {
    return makeUrl(DESIGNER_PATH);
  };
  return {
    createTemplate: createTemplate,
    downloadTemplate: downloadTemplate,
    uploadTemplate: uploadTemplate,
    templateFile: templateFile,
    viewForm: viewForm,
    manageTemplates: manageTemplates,
    designer: designer
  };
};
var _default = exports["default"] = urlBuilder;